import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@mui/material";
import { Paper } from "@mui/material";
import React from "react";
import { formatDate } from "../utils/formatDate";

const DeletedExpenseDetails = ({
  deletedExpenseDetails,
}: {
  deletedExpenseDetails: any;
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ fontSize: "small" }}>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Expense Type
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Amount
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Paid To
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Date
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Contact Number
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Location
            </TableCell>
            <TableCell
              sx={{ fontSize: "0.55rem", border: "1px solid #e0e0e0" }}
            >
              Updated On
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deletedExpenseDetails?.map((expense: any) => (
            <TableRow
              key={expense.id}
              sx={{
                backgroundColor: "#fafafa",
              }}
            >
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {expense.expenseType}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {expense.amount}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {expense.paidTo}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {formatDate(expense.expenseDate)}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {expense.contactNumber}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {expense.location}
              </TableCell>
              <TableCell
                sx={{ border: "1px solid #e0e0e0", fontSize: "0.55rem" }}
              >
                {formatDate(expense.updatedAt)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeletedExpenseDetails;
